module.exports = __webpack_public_path__ + "static/media/productTypeCash.61e7e49d.svg";